import React, { FC, HTMLProps } from 'react'
import { StyledLink } from './Link.elements'

type Props = HTMLProps<HTMLAnchorElement> & {
  inverted?: boolean
}

export const Link: FC<Props> = (props) => (
  <StyledLink {...props} />
)
